"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useBreadcrumbContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useBreadcrumbContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useBreadcrumbContextValues_unstable(state) {
    const { size } = state;
    return _react.useMemo(()=>({
            size
        }), [
        size
    ]);
}
